const tariffTypes = [
  {
    label: 'в день',
    value: 'day',
  },
  {
    label: 'в час',
    value: 'hour',
  },
  {
    label: 'за смену',
    value: 'shift',
  },
  {
    label: 'договорная',
    value: 'contract',
  },
];

export default tariffTypes;
